import { render } from "./FavoritProductsFilter.vue?vue&type=template&id=1f9dd810"
import script from "./FavoritProductsFilter.vue?vue&type=script&lang=js"
export * from "./FavoritProductsFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__